<template>
	<div id="app">
		<router-view />
		<!-- 微信分享浮窗-不知道需不需要 -->
		<!-- <QRCodeFloat :logo-url="getImg()" /> -->
	</div>
</template>
<script>
// import { initWxConfig, setWxShare } from '@/utils/wechatShare';
import QRCodeFloat from '@/components/WeChatShare.vue';
export default {
	async mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
		});
		// var currentTitle = document.title;
		// try {
		// 	const a = await initWxConfig();

		// 	console.log('开始调用 setWxShare...');
		// 	setWxShare({
		// 		title: currentTitle,
		// 		// desc: '由-国研网-分享内容',
		// 		// link: window.location.href.split('#')[0],
		// 		imgUrl: 'https://www.drcnet.com.cn/share.jpg',
		// 		success: () => {
		// 			console.log('分享成功');
		// 		},
		// 	});
		// 	// console.log('setWxShare 调用完成')
		// } catch (error) {
		// 	console.error('微信分享配置失败:', error);
		// 	console.error('错误详情:', error.message, error.stack);
		// }
	},
	methods: {
		getImg() {
			return require('./assets/share.jpg');
		},
	},
};
</script>
<style lang="less">
@media screen and (max-width: 769px) {
	#app {
		// max-width: 769px;
	}
	.spanATitle {
		color: #363636;
		cursor: pointer;
	}
	.spanATitle:hover {
		color: #015293;
	}
	::v-deep body {
		min-width: 100%;
	}
}
</style>
